/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import config from '../config/fullProvenance.config.json';
import axios from 'axios';
import { LoggerModule } from '@vlinder-web/logger-module-react';
import { any } from 'prop-types';
import { toast } from 'react-hot-toast';
import { camelCase, capitalCase } from 'change-case';
import { THUMB_NAIL, NO_IMAGE } from '../../../assets/images';
import formData from '../config/feedback.config.json';

const log: any = LoggerModule?.getInstance();

export interface IFullProvenanceMethods extends IPluginMethodMap {
  getFullProvenance(args: any, apiURL: string): Promise<any>;
  getOCRFullProvenance(args: any, apiURL: string): Promise<any>;
}

export interface FullProvenanceProps {
  barcode: string;
  apiURL: string;
  templateAPIURL?: string;
}

export interface getOCRFullProvenanceProps {
  barcode: string;
  batch: string;
  fssai: string;
  mfgDate: string;
  apiURL?: string;
  templateAPIURL?: string;
  latitude?: string;
  longitude?: string;
}

export class FullProvenanceService implements IAgentPlugin {
  readonly methods?: IFullProvenanceMethods;

  constructor() {
    this.methods = {
      getFullProvenance: this.getFullProvenance.bind(this),
      getOCRFullProvenance: this.getOCRFullProvenance.bind(this),
    };
  }

  private _getEncodedQRValue() {
    let urlParams = window.location.href;
    let params = urlParams.split('/');
    console.log(`url in provider:`, params[params?.length - 1]);
    let id = decodeURIComponent(params[params?.length - 1]);
    if (id) {
      id = String(id).trim();
      return id;
    } else {
      return false;
    }
  }
  private _getImage(images: any[]) {
    let _res: any[] = [];
    images &&
      Array.isArray(images) &&
      images.length > 0 &&
      images.map((item: any, index: number) => {
        if (item) {
          _res.push({
            original: item,
            thumbnail: item,
            thumbnailHeight: '100',
            thumbnailClass: 'image-thumb',
            type: 'image',
          });
        }
      });
    console.log(` imagesp :`, _res);

    return _res;
  }

  private _getImages(images: any[], videos: any, videoURL: string) {
    console.log(`_getImages : :`, images, videos, videoURL);
    let _res: any[] = [];
    images &&
      Array.isArray(images) &&
      images.length > 0 &&
      images.map((item: any, index: number) => {
        if (item) {
          _res.push({
            original: item?.image ? item?.image : item,
            thumbnail: item?.image ? item?.image : item,
            thumbnailHeight: '100',
            thumbnailClass: 'image-thumb',
            type: 'image',
          });
        }
      });

    videoURL &&
      _res.push({
        original: THUMB_NAIL,
        thumbnail: THUMB_NAIL,
        thumbnailHeight: '100',
        thumbnailClass: 'image-thumb',
        type: 'video',
        embedUrl: `${videoURL}${'#t-0.4'}`,
      });

    videos &&
      Array.isArray(videos) &&
      videos.forEach((item: any, index: number) => {
        _res.push({
          original: THUMB_NAIL,
          thumbnail: THUMB_NAIL,
          thumbnailHeight: '100',
          thumbnailClass: 'image-thumb',
          type: 'video',
          embedUrl: `${item?.src}`,
        });
      });
    console.log(` images :`, _res);

    return _res;
  }

  private _getProvImages(images: string[]) {
    let _res: any[] = [];
    images &&
      Array.isArray(images) &&
      images.length > 0 &&
      images.map((item: any, index: number) => {
        if (item && item?.image) {
          _res.push({
            original: item?.image,
            thumbnail: item?.image,
          });
        }
      });
    console.log(` images :`, _res);

    return _res;
  }

  private _getImageUrl(images: any[]) {
    let _res: string = '';
    _res =
      images && Array.isArray(images) && images.length > 0
        ? images[0]?.image
        : NO_IMAGE;

    return _res;
  }

  private _getProductCardData(data: any) {
    let _res: any = {
      title: data?.product?.title,
      volume: data?.product?.volume,
      price: data?.product?.price,
      info: data?.product?.subtitle,
      //"Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum." ??
    };
    log.info(`data in _getProductCardData :`, data);
    return _res;
  }

  private _getDefaultCenter(geoJson: any) {
    if (geoJson) {
      let coordinates: any[] =
        geoJson?.features &&
        Array.isArray(geoJson?.features) &&
        geoJson?.features.length > 0
          ? geoJson?.features[0]?.geometry?.coordinates
          : [];
      if (coordinates && coordinates.length > 0) {
        let defaultCenter = {
          lng: coordinates[0],
          lat: coordinates[1],
        };

        console.log(`defaultCenter in service:`, defaultCenter);
        return defaultCenter;
      }
    }
  }

  private _getMarkers(geoJson: any) {
    if (geoJson && Object.keys(geoJson).length > 0) {
      let markers: any = [];
      geoJson?.features &&
        Array.isArray(geoJson?.features) &&
        geoJson?.features.length > 0 &&
        geoJson?.features.forEach((item: any, index: number) => {
          if (item?.geometry?.type === 'Point') {
            item?.geometry?.coordinates &&
              Array.isArray(item?.geometry?.coordinates) &&
              item?.geometry?.coordinates.length > 0 &&
              markers.push({
                lng: item?.geometry?.coordinates[0],
                lat: item?.geometry?.coordinates[1],
              });
          }
        });
      console.log(`geoJson in service:`, markers);
      return markers;
    }
  }

  private _getLocation(data: any) {
    const _data = data && Array.isArray(data) && data.length > 0 ? data : [];
    let _res = _data.find((item) =>
      item?.label && camelCase(item?.label) === 'location' ? item?.value : ''
    );

    console.log(`_getLocation : `, _res);

    return _res?.value ?? '';
  }

  private _getDate(data: any) {
    const _data = data && Array.isArray(data) && data.length > 0 ? data : [];
    let _res = _data.find((item) => {
      if (item?.label) {
        let _res1 =
          camelCase(item?.label) === 'date'
            ? item?.value
            : camelCase(item?.label) === 'mfgdate'
            ? item?.value
            : camelCase(item?.label) === 'grdate'
            ? item?.value
            : '';
        return _res1 ?? '';
      } else return '';
    });

    console.log(`_getDate : `, _res);

    return _res?.value;
  }

  //signature outside card extra content will render here

  private getVenusFooter = (data: any) => {
    let _res: any[] = [];
    data &&
      Array.isArray(data) &&
      data.length > 0 &&
      data.map((item: any, index: number) => {
        if (
          item?.label === 'Mfgdate'
            ? item?.label === 'Mfgdate'
            : item?.label === 'grdate'
        ) {
          _res.push({
            text: item?.value,
            icon: {
              name: 'calendar',
              type: 'simple-line-icon',
              size: '13px',
            },
          });
        } else if (
          item?.label === 'Unit Name'
            ? item?.label === 'Unit Name'
            : item?.label === 'Source city'
        ) {
          _res.push({
            text: item?.value,
            icon: {
              name: 'location-pin',
              type: 'simple-line-icon',
              size: '15px',
            },
          });
        }
      });
    console.log(`footer for check`, _res);
    return _res;
  };

  private _getMercuryProvData(provCreds: any, provData: any, gtin: string) {
    let res: any = [];
    provCreds &&
      provCreds?.data &&
      Array.isArray(provCreds?.data) &&
      provCreds?.data.length > 0 &&
      provCreds?.data.map((item: any, inedx: number) => {
        console.log(`provenance Data item:`, item, res);
        provData &&
          Array.isArray(provData) &&
          provData.length > 0 &&
          provData.map((ele: any, eleIndex: number) => {
            console.log(`provenance Data ele:`, ele);
            if (item?.credTxId === ele?.credTxId) {
              res.push({
                title: item?.level,
                subtitle: 'LEVEL',
                data: [
                  {
                    ...ele,
                    images: this._getProvImages(
                      ele?.ProvStepImages?.provImages
                    ),
                    productTitleCard: ele?.ProvStepTitleCard,
                    provenanceStepTitle: ele?.ProvDetailInfo,
                    provenanceDetailInfo: {
                      ...ele?.ProvDetailInfo,
                      defaultCenter: this._getDefaultCenter(
                        ele?.provMapProps?.geojson
                      ),
                      provGeoJson: this._getMarkers(ele?.provMapProps?.geojson),
                      defaultZoom: 7,
                      googleMapAPIKey: config?.googleMapAPIKey,
                    },
                    gtinKey: gtin,
                    description: ele?.ProvDetailInfo?.subtitle
                      ? ele?.ProvDetailInfo?.subtitle
                      : ele?.ProvDetailInfo?.aboutProvInfo,
                    title: ele?.ProvDetailInfo?.title
                      ? ele?.ProvDetailInfo?.title
                      : '',
                    tag: ele?.ProvDetailInfo?.tag
                      ? ele?.ProvDetailInfo?.tag
                      : '',
                  },
                ],
              });
            }
          });
      });
    let _updatedResponse: any[] = [];

    res &&
      Array.isArray(res) &&
      res.length > 0 &&
      res.map((item: any, index: number) => {
        let _temp = _updatedResponse;
        let match = false;
        if (_temp && Array.isArray(_temp) && _temp.length > 0) {
          _temp = _temp.map((ele: any, eleIndex: number) => {
            if (item?.title === ele?.title && !match) {
              match = true;
              return {
                ...ele,
                data: [...ele?.data, { ...item?.data[0] }],
              };
            } else {
              return {
                ...ele,
              };
            }
          });
          if (!match) {
            _updatedResponse.push({
              ...item,
            });
          } else {
            _updatedResponse = _temp;
          }
          console.log(`temp provenance data: `, _temp);
          //return _temp;
        } else {
          console.log(`temp provenance data item 1: `, item);
          _updatedResponse.push({
            ...item,
          });
        }
      });

    console.log(`mercury provenance Data :`, res, _updatedResponse);
    return _updatedResponse;
  }

  private _getVenusProvData(provCredData: any) {
    let _res: any = {
      _id: provCredData?._id ? provCredData?._id : '',
      name: provCredData?.name ? provCredData?.name : '',
      data: [], // _data here
    };
    let _subData: any[] = [];
    console.log(`provenance Data item _getVenusProvData:`, provCredData);
    provCredData?.staticDynamicdata &&
      Array.isArray(provCredData?.staticDynamicdata) &&
      provCredData?.staticDynamicdata.length > 0 &&
      provCredData.staticDynamicdata.map((item: any, index: number) => {
        console.log(`provenance Data item:`, item);
        const images = item?.ProvStepImages?.provImages;
        let image =
          images &&
          Array.isArray(images) &&
          images.length > 0 &&
          images.length === 1
            ? images[0]?.image
            : images[1]?.image;
        _subData.push({
          ...item,
          key: index + 1,
          image: image,
          //images : this._getProvImages(item?.product?.images),
          images: this._getImages(
            item?.ProvStepImages?.provImages,
            item?.ProvStepImages?.provImages,
            item?.ProvStepImages?.provImages?.VideoUrl
          ),
          // location: this._getLocation(
          //   item?.ProvDetailInfo?.provInfoList
          // ),
          gtinKey: '',
          credTxId: '',
          //date: this._getDate(item?.ProvDetailInfo?.provInfoList),
          provenanceDetailInfo: {
            ...item?.ProvDetailInfo,
            // info: this._getProvInfo(item?.ProvDetailInfo),
            defaultCenter: this._getDefaultCenter(
              // config.provenanceProdCreds?.staticDynamicdata?.geojson
              item?.provMapProps?.geojson
            ),
            provGeoJson: this._getMarkers(item?.provMapProps?.geojson),
            defaultZoom: 12,
            googleMapAPIKey: config?.googleMapAPIKey,
          },
          description: item?.ProvDetailInfo?.subtitle
            ? item?.ProvDetailInfo?.subtitle
            : item?.ProvDetailInfo?.aboutProvInfo,
          title: item?.ProvDetailInfo?.title ? item?.ProvDetailInfo.title : '',
          blockTitle: item?.ProvDetailInfo?.title
            ? item?.ProvDetailInfo?.title
            : '',
          tag: item?.ProvDetailInfo?.tag ? item?.ProvDetailInfo?.tag : '',
          diamondIconColor: '#006F3B',
          diamondToCircle: true,
          footer: this.getVenusFooter(item?.ProvDetailInfo?.provInfoList),
        });
      });

    console.log(`venus provenance Data :`, _subData);
    _res.data = [..._subData];
    console.log(`venus provenance Data :`, _res);

    return [_res];
  }

  private _getMarsProvData = (provCreds: any, provData: any, gtin: string) => {
    let res: any = [];
    provCreds &&
      provCreds?.data &&
      Array.isArray(provCreds?.data) &&
      provCreds?.data.length > 0 &&
      provCreds?.data.map((item: any, inedx: number) => {
        console.log(`provenance Data item:`, item);
        provData &&
          Array.isArray(provData) &&
          provData.length > 0 &&
          provData.map((ele: any, eleIndex: number) => {
            console.log(`provenance Data element:`, ele);
            if (item?.credTxId === ele?.credTxId) {
              res.push({
                title: item?.level,
                subtitle: 'LEVEL',
                data: [
                  {
                    ...ele,
                    images: this._getProvImages(
                      ele?.ProvStepImages?.provImages
                    ),
                    imageUrl: {
                      uri: this._getImageUrl(ele?.ProvStepImages?.provImages),
                    },
                    icon: {
                      uri: ele?.iconURL ? ele?.iconURL : '',
                    },
                    organizationLogo: ele?.organizationLogo
                      ? ele?.organizationLogo
                      : '',
                    location: this._getLocation(
                      ele?.ProvDetailInfo?.provInfoList
                    ),
                    date: this._getDate(ele?.ProvDetailInfo?.provInfoList),
                    productTitleCard: ele?.ProvStepTitleCard,
                    provenanceStepTitle: ele?.ProvDetailInfo,
                    provenanceDetailInfo: {
                      ...ele?.ProvDetailInfo,
                      defaultCenter: this._getDefaultCenter(
                        ele?.provMapProps?.geojson
                      ),
                      provGeoJson: this._getMarkers(ele?.provMapProps?.geojson),
                      defaultZoom: 15,
                      googleMapAPIKey: config?.googleMapAPIKey,
                    },
                    gtinKey: gtin,
                    description: ele?.ProvDetailInfo?.subtitle
                      ? ele?.ProvDetailInfo?.subtitle
                      : ele?.ProvDetailInfo?.aboutProvInfo,
                    title: ele?.ProvDetailInfo?.title
                      ? ele?.ProvDetailInfo?.title
                      : '',
                    tag: ele?.ProvDetailInfo?.tag
                      ? ele?.ProvDetailInfo?.tag
                      : '',
                  },
                ],
              });
            }
          });
      });
    //  console.log(`mars provenance Data :`, res);
    //       return res?.data;

    let _updatedResponse: any[] = [];

    res &&
      Array.isArray(res) &&
      res.length > 0 &&
      res.map((item: any, index: number) => {
        let _temp = _updatedResponse;
        let match = false;
        if (_temp && Array.isArray(_temp) && _temp.length > 0) {
          _temp = _temp.map((ele: any, eleIndex: number) => {
            if (item?.title === ele?.title && !match) {
              match = true;
              return {
                ...ele,
                data: [...ele?.data, { ...item?.data[0] }],
              };
            } else {
              return {
                ...ele,
              };
            }
          });
          if (!match) {
            _updatedResponse.push({
              ...item,
            });
          } else {
            _updatedResponse = _temp;
          }
          console.log(`temp provenance data: `, _temp);
          //return _temp;
        } else {
          console.log(`temp provenance data item 1: `, item);
          _updatedResponse.push({
            ...item,
          });
        }
      });

    console.log(`mars provenance Data :`, res, _updatedResponse?.data);
    return _updatedResponse[0]?.data;
  };

  private _getProvenanceData(
    provCreds: any,
    provData: any,
    gtin: string,
    templateName: string
  ) {
    console.log(` in _getProvenanceData:`, templateName);
    switch (templateName) {
      case 'mercury':
        return this._getMercuryProvData(provCreds, provData, gtin); //trag 1.0 provenance
      // case "venus":
      //   return this._getVenusProvData(provCreds, provData, gtin); //singature provenance
      case 'earth':
        return this._getMarsProvData(provCreds, provData, gtin); // new provenance
      case 'mars':
        //return config?.provenanceTimeline1_0?.timeLineData;
        return this._getMarsProvData(provCreds, provData, gtin);
      default:
        return this._getMercuryProvData(provCreds, provData, gtin);
    }

    //add formating according to type of provenance and data you get from response
    //return config?.provenanceTimeline1_0?.timeLineData
    //return config?.signatureProvenance;
    //return data?.provenance?.data ? data?.provenance?.data : null;
  }

  private _getCredTx(_creds: any) {
    console.log(`bla credentials in _getCredTx`, _creds);
    let _result: string[] = [];

    const existOrNot = (_credIds: string[]) => {
      let _res: string[] = [];
      if (_result && _result.length > 0 && _credIds && _credIds.length > 0) {
        _credIds.map((item: any, index: number) => {
          let isMached = false;
          _result.map((ele: any, eleIndex: number) => {
            if (item === ele) {
              isMached = true;
            }
          });
          if (!isMached) {
            _res.push(item);
          }
        });
      }
      return _res;
    };

    const _fgCredTxId =
      _creds && Array.isArray(_creds) && _creds.length > 0
        ? _creds[0]?.parentCredTxId
          ? _creds[0]?.parentCredTxId
          : undefined
        : undefined;
    if (_fgCredTxId) {
      _result.push(_fgCredTxId);
    }
    _creds &&
      Array.isArray(_creds) &&
      _creds.length > 0 &&
      _creds.map((item: any, index: number) => {
        if (
          item?.childId &&
          Array.isArray(item?.childId) &&
          item?.childId.length > 0
        ) {
          const _credIds = existOrNot(item?.childId);
          _credIds && _result.push(..._credIds);
        } else {
          const _credIds = existOrNot([item?.credTxId]);
          _credIds && _result.push(..._credIds);
        }
      });

    console.log(`bla _result ::`, _result);

    return _result;
  }

  getFeedbackModal(feedbackModalData: any) {
    console.log(`customFeedbackKeys ::`, feedbackModalData);
    const _addFields = feedbackModalData?.customFeedbackKeys;
    let _res = { ...feedbackModalData };
    let _fields = {
      ...formData?.fields,
      email: {
        validators: {
          notEmpty: {
            message: 'The Email is required',
          },
          regexp: {
            regexp: /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/,
            message: 'Please enter valid email address',
          },
        },
      },
    };
    _res.fields = _fields;
    let _formFields: any[] = formData?.formFields;
    if (
      _addFields &&
      Array.isArray(_addFields) &&
      _addFields.length > 0 &&
      _formFields &&
      Array.isArray(_formFields) &&
      _formFields.length > 0
    ) {
      _addFields.map((item: any, index: number) => {
        _formFields.push({
          label: item?.header && capitalCase(item?.header),
          name: item?.accessor,
          type: item?.type ? item?.type : 'text-input',
          fieldProps: {},
        });
      });
    }
    _res.formFields = _formFields;

    return _res;
  }

  //normal qr scanning or opening from url
  async getFullProvenance(args: FullProvenanceProps) {
    console.log(`args in full provenance service :`, args);
    let _encodedQR = this._getEncodedQRValue();
    try {
      const res = await axios.post(
        `${args.apiURL}${config?.fullProvenanceEP}`,
        {
          barcode: _encodedQR,
          appMode: 'web',
          scanType: 'QR',
        },
        {
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
        }
      );
      if (res?.data) {
        console.log(` On Success of getting provenance data:`, res?.data);
        let _data = res?.data?.data;
        let typeRes = await axios.post(
          `${args.templateAPIURL}${config?.templateTypeEP}`,
          {
            gtin: _data?.product?.gtin,
          },
          {
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
            },
          }
        );
        console.log(`typeRes :`, typeRes?.data);
        // typeRes.data.templateName = "mars";
        // console.log(`modifiedtypeRes :`, typeRes?.data);

        let _credTx = _data
          ? this._getCredTx(_data?.provenanceProdCreds?.data)
          : [];
        // let _credTx = _data && _data?.provenanceProdCreds?.data;
        // _credTx =
        //   _credTx && Array.isArray(_credTx) && _credTx.length > 0
        //     ? _credTx[0]?.childId
        //     : [];
        console.log(`_credTx ::`, _credTx);

        let provenanceData: any;
        if (
          _data?.provenanceProdCreds?._id &&
          typeRes?.data?.templateName !== 'venus' // here checking if type is venus(signature) then no need to call provenance api
        ) {
          provenanceData = await axios.post(
            `${args.apiURL}${config?.provenanceEP}`,
            {
              gtin: _data?.product?.gtin,
              credTxIds: _credTx,
              provId: _data?.provenanceProdCreds?._id,
            },
            {
              headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
              },
            }
          );
        }
        //console.log(`provenanceData :`, provenanceData);
        return {
          ..._data,
          images: this._getImages(
            _data?.product?.images,
            _data?.product?.videos,
            _data?.batch?.promoVideoUrl
          ),
          productCardData: this._getProductCardData(_data),
          footerButtons: _data?.batch,
          provenanceData:
            typeRes?.data?.templateName === 'venus' // venus always be OCR flow but added here in case
              ? this._getVenusProvData(
                  //if type is venus(signature) then get venus provenance data and passing else normal flow
                  _data?.provenanceProdCreds
                  //here pass provenanceProdCreds from config if you want to tesr i.e "config.provenanceProdCreds" and hardcode template type as "venus" in required places
                )
              : this._getProvenanceData(
                  _data?.provenanceProdCreds,
                  provenanceData?.data,
                  _data?.product?.gtin,
                  typeRes?.data?.templateName ?? 'mercury'
                ),
          isAgeVerReq: _data?.others?.isAgeVerReq,
          ageDetails: _data?.others?.age_popup_details?.ageVerifcationData,
          modalFeedbackData: this?.getFeedbackModal(_data?.feedbackModal),
          templateName: typeRes?.data?.templateName ?? 'mercury',
        };
      }
    } catch (err: any) {
      console.log(` on error of getFUllProvenance :`, err);
      toast.error(
        `${
          err?.response?.data?.error?.error_message ??
          err?.response?.data?.error_message ??
          'Could not able get provenance'
        }`,
        { duration: 4000 }
      );
      // return err;
    }
  }

  //on ocr flow get full provenance by scanning label
  async getOCRFullProvenance(args: getOCRFullProvenanceProps) {
    console.log(`args in getOCRFullProvenance service :`, args);
    try {
      const res = await axios.post(
        `${args.apiURL}${config?.fullProvenanceEP}`,
        {
          barcode: args?.barcode,
          batch: args?.batch,
          fssai: args?.fssai,
          mfgDate: args?.mfgDate,
          appMode: 'web',
          scanType: 'Label',
          lat: args?.latitude,
          lon: args?.longitude,
        },
        {
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
        }
      );
      if (res?.data) {
        console.log(` on success of result :`, res?.data);
        let _data = res?.data?.data;
        let typeRes = await axios.post(
          `${args.templateAPIURL}${config?.templateTypeEP}`,
          {
            gtin: _data?.product?.gtin,
          },
          {
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
            },
          }
        );
        console.log(`typeRes :`, typeRes?.data);
        // typeRes.data.templateName = "mars";
        // console.log(`modifiedtypeRes :`, typeRes?.data);

        // let _credTx = _data && _data?.provenanceProdCreds?.data;
        // _credTx =
        //   _credTx && Array.isArray(_credTx) && _credTx.length > 0
        //     ? _credTx[0]?.childId
        //     : [];
        let _credTx = _data
          ? this._getCredTx(_data?.provenanceProdCreds?.data)
          : [];
        console.log(`_credTx ::`, _credTx);

        let provenanceData: any;
        if (
          _data?.provenanceProdCreds?._id &&
          typeRes?.data?.templateName !== 'venus'
        ) {
          provenanceData = await axios.post(
            `${args.apiURL}${config?.provenanceEP}`,
            {
              gtin: _data?.product?.gtin,
              credTxIds: _credTx,
              provId: _data?.provenanceProdCreds?._id,
            },
            {
              headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
              },
            }
          );
        }
        console.log(`provenanceData :`, provenanceData);
        return {
          ..._data,
          images: this._getImages(
            _data?.product?.images,
            _data?.product?.videos,
            _data?.batch?.promoVideoUrl
          ),
          productCardData: this._getProductCardData(_data),
          footerButtons: _data?.batch,
          provenanceData:
            typeRes?.data?.templateName === 'venus'
              ? this._getVenusProvData(_data?.provenanceProdCreds)
              : this._getProvenanceData(
                  _data?.provenanceProdCreds,
                  provenanceData?.data,
                  _data?.product?.gtin,
                  typeRes?.data?.templateName ?? 'mercury'
                ),
          isAgeVerReq: _data?.others?.isAgeVerReq,
          ageDetails: _data?.others?.age_popup_details?.ageVerifcationData,
          modalFeedbackData: this?.getFeedbackModal(_data?.feedbackModal),
          templateName: typeRes?.data?.templateName ?? 'mercury',
        };
      }
    } catch (err: any) {
      console.log(` on error of getOCRFUllProvenance :`, err);
      toast.error(
        `${
          err?.response?.data?.error?.error_message ??
          err?.response?.data?.error_message ??
          'Could not able get provenance'
        }`,
        {
          duration: 3000,
        }
      );
    }
  }
}
